import { createContext, useContext, useRef, useState } from 'react';
import useMobile from 'hooks/use_mobile';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const isMobile = useMobile();
  const [sidebarVisible, setSidebarVisible] = useState(!isMobile);

  const sidebarToggleFocusRef = useRef(false);

  return (
    <MenuContext.Provider value={{ sidebarVisible, setSidebarVisible, sidebarToggleFocusRef }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
